import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Business } from '../../../models/business.interface';

@Component({
    selector: 'app-search-business-dialog',
    templateUrl: './search-business-dialog.component.html',
    standalone: false
})
export class SearchBusinessDialogComponent implements OnInit {
  searchingBusinesses: boolean = false;
  businessControl: UntypedFormControl = new UntypedFormControl();
  businesses: Business[] = [];

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<SearchBusinessDialogComponent>
  ) {}

  ngOnInit(): void {
    this.loadBusinesses();
  }

  loadBusinesses(): void {
    this.searchingBusinesses = true;
    this.http.get<Business[]>(environment.apiURL1 + 'resources/list-businesses').subscribe({
      next: (response: Business[]) => {
        this.businesses = response;
        this.searchingBusinesses = false;
      },
      error: (error) => {
        console.error('Error loading businesses:', error);
        this.searchingBusinesses = false;
      }
    });
  }

  confirm(): void {
    this.dialogRef.close(this.businessControl.value);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}